module.exports = __webpack_public_path__ + "img/swap-arrows.87f54452.svg";